namespace RedBullMOBILE360.CustomerCare {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CustomerCare.ThreeThreeZeroNotificationDialog')
    export class ThreeThreeZeroNotificationDialog extends Serenity.EntityDialog<ThreeThreeZeroNotificationRow, any> {
        protected getFormKey() { return ThreeThreeZeroNotificationForm.formKey; }
        protected getIdProperty() { return ThreeThreeZeroNotificationRow.idProperty; }
        protected getLocalTextPrefix() { return ThreeThreeZeroNotificationRow.localTextPrefix; }
        protected getNameProperty() { return ThreeThreeZeroNotificationRow.nameProperty; }
        protected getService() { return ThreeThreeZeroNotificationService.baseUrl; }
        protected getDeletePermission() { return ThreeThreeZeroNotificationRow.deletePermission; }
        protected getInsertPermission() { return ThreeThreeZeroNotificationRow.insertPermission; }
        protected getUpdatePermission() { return ThreeThreeZeroNotificationRow.updatePermission; }

        protected form = new ThreeThreeZeroNotificationForm(this.idPrefix);
    }
}